import React from 'react';
import dayjs from 'dayjs';
import { Col, Row } from '../../../lib/utils';
import EmptyClass from './EmptyClass';
import ClassDayCard from './ClassDayCard';

const ClassHistoryEntire = ({
    entireList,
    entireFilterList,
    searchText,
    entireToggleState,
    onClickEntireToggleBtn,
}: any) => {
    if (entireFilterList && entireFilterList.length === 0) {
        return (
            <Col style={{ width: 1192 }}>
                <EmptyClass />
            </Col>
        );
    }

    return (
        <Col style={{ width: 1192, gap: 16 }}>
            {entireList?.map((entireItem: any, entireIndex: number) => {
                const yearKey = Object.keys(entireItem)[0];
                const yearMonths = entireItem[yearKey]; // 월 단위 배열

                // 해당 연도의 전체 수업 수 계산
                let yearTotal = 0;
                yearMonths.forEach((monthWrap: any) => {
                    const monthArr = monthWrap[Object.keys(monthWrap)[0]];
                    if (Array.isArray(monthArr)) {
                        monthArr.forEach((day: any) => {
                            const dayKeys = Object.keys(day);
                            const dayObj = day[dayKeys[0]];
                            const filtered = searchText
                                ? dayObj.filter((e: any) => e.alias.includes(searchText))
                                : dayObj;
                            yearTotal += filtered.length;
                        });
                    }
                });

                if (yearTotal === 0) return <div key={'y' + entireIndex} />;

                return (
                    <Col key={'entireYear' + entireIndex} style={{ gap: 10 }}>
                        {/* 연도 헤더 — 컴팩트 */}
                        <Row
                            style={{
                                alignItems: 'baseline',
                                gap: 10,
                                padding: '4px 4px 6px',
                                borderBottom: '2px solid #E5E7EB',
                            }}
                        >
                            <span style={{ fontSize: 18, fontWeight: 800, color: '#111827', letterSpacing: -0.3 }}>
                                {yearKey}년
                            </span>
                            <span
                                style={{
                                    padding: '2px 10px',
                                    borderRadius: 999,
                                    backgroundColor: '#EFF6FF',
                                    color: '#1D4ED8',
                                    fontSize: 12,
                                    fontWeight: 700,
                                    border: '1px solid #BFDBFE',
                                }}
                            >
                                총 {yearTotal}회
                            </span>
                        </Row>

                        {/* 월 단위 섹션 */}
                        <Col style={{ gap: 10 }}>
                        {yearMonths.map((monthWrap: any, yearIndex: number) => {
                            const monthInnerKey = Object.keys(monthWrap)[0];
                            const monthArr = monthWrap[monthInnerKey];

                            if (!Array.isArray(monthArr) || monthArr.length === 0) return null;

                            // 월 총 수업수 + 대표 날짜(헤더 표기용)
                            let monthTotal = 0;
                            let firstDayTime: string | null = null;
                            monthArr.forEach((day: any) => {
                                const dayKeys = Object.keys(day);
                                const dayObj = day[dayKeys[0]];
                                if (!firstDayTime && dayObj[0]?.startTime) firstDayTime = dayObj[0].startTime;
                                const filtered = searchText
                                    ? dayObj.filter((e: any) => e.alias.includes(searchText))
                                    : dayObj;
                                monthTotal += filtered.length;
                            });

                            if (monthTotal === 0 || !firstDayTime) return null;

                            const monthLabel = dayjs(firstDayTime).format('YYYY년 M월');
                            const monthNum = dayjs(firstDayTime).format('M');
                            // toggleState === true → 펼쳐짐 (기본값은 false = 접힘)
                            const isOpen = !!entireToggleState?.[entireIndex]?.[yearIndex];

                            return (
                                <Col key={'month' + yearIndex} style={{ gap: 8 }}>
                                    {/* 월 토글 헤더 — 컴팩트 */}
                                    <Row
                                        onClick={() => onClickEntireToggleBtn(entireIndex, yearIndex)}
                                        style={{
                                            alignItems: 'center',
                                            gap: 12,
                                            padding: '10px 16px',
                                            backgroundColor: '#F8FAFC',
                                            border: '1px solid #E2E8F0',
                                            borderRadius: 10,
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <span style={{ fontSize: 16, fontWeight: 800, color: '#2563EB' }}>
                                            {monthLabel}
                                        </span>
                                        <span style={{ fontSize: 13, color: '#475569' }}>
                                            총 <b style={{ color: '#2563EB', fontSize: 14 }}>{monthTotal}</b>회 진행
                                        </span>
                                        <div style={{ flex: 1 }} />
                                        <span
                                            style={{
                                                fontSize: 12,
                                                fontWeight: 600,
                                                color: '#6B7280',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: 4,
                                            }}
                                        >
                                            {isOpen ? '접기' : '펼치기'}
                                            <span
                                                style={{
                                                    fontSize: 9,
                                                    transform: isOpen ? 'rotate(180deg)' : 'none',
                                                    transition: 'transform 0.2s',
                                                }}
                                            >
                                                ▼
                                            </span>
                                        </span>
                                    </Row>

                                    {/* 일별 카드 */}
                                    {isOpen && (
                                        <Col style={{ gap: 8 }}>
                                            {monthArr.map((day: any, dayIdx: number) => {
                                                const dayKeys = Object.keys(day);
                                                const dayObj = day[dayKeys[0]];
                                                const dayTime = dayObj[0]?.startTime;
                                                const filtered = searchText
                                                    ? dayObj.filter((e: any) => e.alias.includes(searchText))
                                                    : dayObj;
                                                if (!filtered || filtered.length === 0) return null;
                                                return (
                                                    <ClassDayCard
                                                        key={'entireDay' + dayIdx}
                                                        date={dayTime}
                                                        classes={filtered}
                                                        accentIdx={dayIdx}
                                                    />
                                                );
                                            })}
                                        </Col>
                                    )}
                                </Col>
                            );
                        })}
                        </Col>
                    </Col>
                );
            })}
        </Col>
    );
};

export default ClassHistoryEntire;
